import { useState } from "react"


export type Disclouse = {
  default?: boolean
}

const useDisclouse = () => {

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClose = () => setIsOpen(false);

  const onOpen = () => setIsOpen(true);

  const invertIsOpen = () => setIsOpen((value) => !value);

  return {
    onOpen,
    onClose,
    invertIsOpen,
    isOpen
  }
}

export default useDisclouse
